<template>
  <v-container class="pa-0"  fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Nepatikrintų dokumentų žurnalas') }}</h1>
    <!-- search -->
    <admin-checking-journal-search
      :loading="loading"
      @search="doSearch"
    />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal')
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <template #[`item.status`]="{ item }">
        <el-table-enum enumName="journalType" :item="item.status.toString()" />
      </template>
      <!--main custom templates -->
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            handling
            @approveSignatures="approveSignatures(item)"
            @viewSignatures="viewSignatures(item)"
          />
        </div>
      </template>
      <template #[`item.in_journal_type`]="{ item }">
        <el-table-enum enumName="inJournalType" :item="item.in_journal_type" />
      </template>
      <template #[`item.data_provider_type`]="{ item }">
        <el-table-enum enumName="dataProviderType" :item="item.data_provider_type" />
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import AdminCheckingJournalSearch from './AdminCheckingJournalSearch'
import userRole from '@/mixins/userRole'
import tableParameters from '@/mixins/tableParameters'
import math from '@/mixins/math'

export default {
  name: 'CheckingInJournal',
  components: {
    AdminCheckingJournalSearch,
  },
  mixins: [userRole, tableParameters, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteItem: null,
      listData: [],
      searchData: {},
      notSolvedCounts: [],

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Reg. Nr. nepatikrintų dokumentų žurnale'),
          align: 'start',
          value: 'ns',
          width: '8rem',
        },
        {
          text: this.$t('Nepatikrinto dokumento pavadinimas'),
          align: 'start',
          value: 'in_journal_type',
        },
        {
          text: this.$t('Gavimo data ir laikas'),
          align: 'start',
          value: 'representers_check_date',
          width: '8rem',
        },
        {
          text: this.$t('Duomenų teikėjas'),
          align: 'start',
          value: 'data_provider',
        },
        {
          text: this.$t('Sprendimas'),
          align: 'start',
          value: 'signing_status',
           width: '6rem',
        },
        {
          text: this.$t('Sprendimo data'),
          align: 'start',
          value: 'signing_status_date',
          width: '6.6rem',
        },
        {
          text: this.$t('Reg. Nr. gautų dokumentų žurnale'),
          align: 'start',
          value: 'journal_no',
          width: '8rem',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
  },
  beforeDestroy() {},
  created() {
    // this.getData()
  },
  methods: {
    doSearch(searchData){
      this.searchData = searchData
      this.loading = true
      this.getData(searchData.btn)
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      this.setSortParams()
      
      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`in-journals/ns/list`, data)
        .then((res) => {
          this.listData = res.data.inJournals
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
          page: pagination.page,
          route: this.$route.name,
      })     
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    viewSignatures(item, mode) {
      this.$router.push({
        name: 'journalCheckingForm',
        params: {
          id: item.id,
        },
      })
    },
    approveSignatures(item, mode) {
      this.$router.push({
        name: 'journalCheckingForm',
        params: {
          id: item.id,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
